// Codes `globalData.specieLevels` : « confirmed » est le plus haut niveau (défaut naturaliste), « for-all » l'imposé aux non-naturalistes.
export const SPECIE_LEVEL_CONFIRMED = "confirmed";
export const SPECIE_LEVEL_FOR_ALL = "for-all";

export function resolveSpecieLevelCodes(isNaturalist: boolean, selected: readonly string[] | undefined): string[] {
  if (!isNaturalist) return [SPECIE_LEVEL_FOR_ALL];
  return selected && selected.length ? [...selected] : [SPECIE_LEVEL_CONFIRMED];
}

// Le rang d'un niveau n'est pas exposé : `globalData.specieLevels` arrive trié par rang croissant, l'index en tient lieu.
export function expandToLowerSpecieLevels(orderedLevelCodes: readonly string[], codes: readonly string[]): string[] {
  const highestIndex = codes.reduce((highest, code) => Math.max(highest, orderedLevelCodes.indexOf(code)), -1);
  if (highestIndex < 0) return [...codes];
  return orderedLevelCodes.slice(0, highestIndex + 1);
}
